import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

/**DATOS DUMMY DE VISITAS INICIALES */
const dataInicial = {
    visitas: [ {
        id: 1,
        dia: 1,
        mes: "Enero",
        ano: 2022,
        status: 1,
        fecha: "2-enero-2022",
        empresa: "Empresa 1",
        inspector: "Inspector 1",
        indicacionesAdicionales: "Informacion o indicaciones respectivas a la visita 1"
    },
    {
        id: 2,
        dia: 2,
        mes: "Marzo",
        ano: 2022,
        status: 2,
        fecha: "1-Marzo-2022",
        empresa: "Empresa 2",
        inspector: "Inspector 2",
        indicacionesAdicionales: "Informacion o indicaciones respectivas a la visita 1"
    } ],
    visitasMesActual: []
}

export const CalendarioSlice = createSlice({
    initialState: dataInicial,
    name: 'CalendarioSlice',
    reducers: {
        agregarVisita(state, { payload }) {
            state.visitas.push(payload)
        },
        eliminarVisita(state, {payload}) {
            const filteredVisitas = state.visitas.filter(visita => visita.id !== payload)
            state.visitas = filteredVisitas
        },
        filtrarVisitasMesAno(state, { payload }) {
            state.visitasMesActual = state.visitas.filter(visita => (visita.mes === payload.mes && visita.ano === payload.ano))
        }
    }
})

export const {
    agregarVisita,
    eliminarVisita,
    filtrarVisitasMesAno
} = CalendarioSlice.actions

export const CalendarioReducer = CalendarioSlice.reducer